interface CopilotIconProps {
  ariaLabel?: string
}

const defaultProps: Partial<CopilotIconProps> = {
  ariaLabel: '',
}

export const CopilotIcon: React.FC<CopilotIconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg aria-label={ariaLabel} viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.785 38.2158C59.5623 42.021 46.6561 51 31 51C15.3439 51 2.43768 42.021 0.215011 38.2158C0.0524668 37.9375 0 37.6198 0 37.2987V30.5244C0 30.2436 0.0439853 29.9645 0.149414 29.7036C1.11058 27.325 3.62783 23.8699 6.87651 22.9428C7.3072 21.8531 7.94511 20.2602 8.5403 19.0843C8.44067 18.1846 8.4056 17.2567 8.4056 16.3192C8.4056 12.932 9.13409 9.961 11.3292 7.74857C12.3544 6.71521 13.6266 5.92255 15.1353 5.3267C18.7485 2.43372 23.8937 0 30.9442 0C37.9947 0 43.2515 2.43372 46.8647 5.3267C48.3734 5.92255 49.6456 6.71521 50.6708 7.74857C52.8659 9.961 53.5944 12.932 53.5944 16.3192C53.5944 17.2567 53.5593 18.1846 53.4597 19.0843C54.0549 20.2602 54.6928 21.8531 55.1235 22.9428C58.3722 23.8699 60.8894 27.325 61.8506 29.7036C61.956 29.9645 62 30.2436 62 30.5244V37.2987C62 37.6198 61.9475 37.9375 61.785 38.2158ZM33.1 15.498C32.9901 14.6543 32.9379 13.8988 32.9364 13.2238L32.9363 13.1705C32.9398 11.2122 33.3741 9.93802 34.0679 9.15545C34.949 8.16171 36.7699 7.40037 40.6077 7.8097C44.4959 8.22441 46.6692 9.17548 47.9014 10.4174C49.0943 11.6197 49.721 13.4186 49.721 16.3192C49.721 19.4009 49.2704 21.2217 48.2795 22.3292C47.3374 23.3824 45.482 24.2394 41.4184 24.2394C38.2944 24.2394 36.5082 23.238 35.3664 21.8531C34.1402 20.366 33.4502 18.1875 33.1 15.498ZM28.9 15.498C29.0099 14.6543 29.0621 13.8988 29.0637 13.2238L29.0637 13.1704C29.0602 11.2122 28.6259 9.93801 27.9321 9.15544C27.051 8.1617 25.2301 7.40036 21.3923 7.80969C17.5041 8.2244 15.3308 9.17547 14.0986 10.4174C12.9057 11.6197 12.279 13.4186 12.279 16.3192C12.279 19.4009 12.7296 21.2217 13.7205 22.3292C14.6626 23.3824 16.518 24.2394 20.5816 24.2394C23.7056 24.2394 25.4918 23.238 26.6336 21.8531C27.8598 20.366 28.5498 18.1875 28.9 15.498ZM31.4448 22.9659C31.2965 22.9666 31.5929 22.9659 31.4448 22.9659C31.2966 22.9659 30.7036 22.9666 30.5553 22.9659C30.282 23.4171 29.978 23.8501 29.6396 24.2605C27.6521 26.6709 24.6853 28.0567 20.5816 28.0567C16.1274 28.0567 12.8631 27.1431 10.8151 24.8538C10.6986 24.7236 10.5944 24.5873 10.5944 24.5873L10.3423 24.8538V41.6097C14.0473 43.5941 21.9994 47.1551 31 47.1551C40.0006 47.1551 47.9528 43.5941 51.6577 41.6097V24.8538L51.4056 24.5873C51.4056 24.5873 51.3202 24.7026 51.185 24.8538C49.1369 27.1431 45.8726 28.0567 41.4184 28.0567C37.3147 28.0567 34.3479 26.6709 32.3604 24.2605C32.0221 23.8501 31.7181 23.4171 31.4448 22.9659Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.4555 31.2378C38.8817 31.2378 40.0378 32.3772 40.0378 33.7827V38.8725C40.0378 40.278 38.8817 41.4174 37.4555 41.4174C36.0294 41.4174 34.8733 40.278 34.8733 38.8725V33.7827C34.8733 32.3772 36.0294 31.2378 37.4555 31.2378Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5445 31.2378C25.9706 31.2378 27.1267 32.3772 27.1267 33.7827V38.8725C27.1267 40.278 25.9706 41.4174 24.5445 41.4174C23.1183 41.4174 21.9622 40.278 21.9622 38.8725V33.7827C21.9622 32.3772 23.1183 31.2378 24.5445 31.2378Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PlayIcon: React.FC<CopilotIconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24905 3.69194C5.82218 3.45967 5.30225 3.76868 5.30225 4.25466V15.7452C5.30225 16.2312 5.82218 16.5402 6.24906 16.3079L16.8079 10.5626C17.2538 10.32 17.2538 9.67983 16.8079 9.4372L6.24905 3.69194ZM4.021 4.25466C4.021 2.79672 5.58078 1.86969 6.86142 2.56651L17.4203 8.31176C18.758 9.03966 18.758 10.9602 17.4203 11.6881L6.86143 17.4333C5.58079 18.1301 4.021 17.2031 4.021 15.7452V4.25466Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PauseIcon: React.FC<CopilotIconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.15812 2.3125C4.33257 2.3125 3.66333 2.98174 3.66333 3.80729V16.1927C3.66333 17.0183 4.33257 17.6875 5.15812 17.6875H8.1477C8.97326 17.6875 9.6425 17.0183 9.6425 16.1927V3.80729C9.6425 2.98174 8.97326 2.3125 8.1477 2.3125H5.15812ZM4.94458 3.80729C4.94458 3.68936 5.04019 3.59375 5.15812 3.59375H8.1477C8.26564 3.59375 8.36125 3.68936 8.36125 3.80729V16.1927C8.36125 16.3106 8.26564 16.4062 8.1477 16.4062H5.15812C5.04019 16.4062 4.94458 16.3106 4.94458 16.1927V3.80729ZM12.8456 2.3125C12.0201 2.3125 11.3508 2.98174 11.3508 3.80729V16.1927C11.3508 17.0183 12.0201 17.6875 12.8456 17.6875H15.8352C16.6608 17.6875 17.33 17.0183 17.33 16.1927V3.80729C17.33 2.98174 16.6608 2.3125 15.8352 2.3125H12.8456ZM12.6321 3.80729C12.6321 3.68936 12.7277 3.59375 12.8456 3.59375H15.8352C15.9531 3.59375 16.0487 3.68936 16.0487 3.80729V16.1927C16.0487 16.3106 15.9531 16.4062 15.8352 16.4062H12.8456C12.7277 16.4062 12.6321 16.3106 12.6321 16.1927V3.80729Z"
        fill="currentColor"
      />
    </svg>
  )
}

try{ CopilotIcon.displayName ||= 'CopilotIcon' } catch {}
try{ PlayIcon.displayName ||= 'PlayIcon' } catch {}
try{ PauseIcon.displayName ||= 'PauseIcon' } catch {}